.cardImage {
  cursor: pointer;
  position: absolute;
  filter: drop-shadow(0px 3px 2px rgba(0, 0, 0, 0.4));
}

.handWrapper {
  position: relative;
}

.handWrapper + .handWrapper {
  margin-top: 12px;
}

.cardsWrapper {
  margin-top: 4px;
  position: relative;
}

.squareBorderAnim {
  position: relative;
  top: 0;
}
